import BaseService from "../baseService";
class LoginsAdicionais extends BaseService {
    constructor(id) {
        const resource = "login-adicional";
        let relationship = {};
        super(id, relationship, resource);
    }
}

export default (id) => new LoginsAdicionais(id);
